import comp from "./GroupSelectDropdown";
export default comp;
